Wee.fn.make('popup', {
    init: function() {
        var scope = this;

        $.events.on({
            'ref:popupBtn': {
                click: function(e, el) {
                    var blockId = $(el).data('id');

                    $('ref:popupOverlay').hide();
                    $('ref:popupOverlay-' + blockId).show();
                    $('ref:popupClose-' + blockId)[0].focus();
                    $($._body).toggleClass('-is-disabled');
                    e.preventDefault();
                }
            },
            'ref:popupClose': {
                click: function(e) {
                    $('ref:popupOverlay').hide();
                    $('ref:popupBtn-' + $(e.target).data('id'))[0].focus();
                    $($._body).toggleClass('-is-disabled');
                }
            },
            'ref:popupOverlay': {
                keydown: function(e, el) {
                    if ((e.shiftKey && e.keyCode === 9) || e.keyCode === 9) {
                        scope.trapFocus(e, $('ref:popupClose-' + $(el).data('id')));
                    } else if (e.keyCode === 27) {
                        $('ref:popupOverlay').hide();
                        $('ref:popupBtn-' + $(e.target).data('id'))[0].focus();
                        $($._body).toggleClass('-is-disabled');
                    }
                }
            }
        });
    },

    trapFocus: function(e, el) {
        var $buttons = el,
            first = $buttons[0],
            last = $buttons[$buttons.length - 1];

        if (e.shiftKey) {
            if (document.activeElement === first) {
                last.focus();
                e.preventDefault();
            }
        } else if (document.activeElement === last) {
            first.focus();
            e.preventDefault();
        }
    }
});

Wee.popup.init();
